import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-materialize";
import $ from "jquery";
import config from "config";
import API from "utils/API";
import Html from "utils/Html";

import ViewProfileBtnChange from "components/employees/features/viewprofile/btn.change";
import ViewProfileBtnGContact from "components/employees/features/viewprofile/btn.gcontact";
import ViewProfileBtnMyProfile from "components/employees/features/viewprofile/btn.myprofile";

const Feature = {};
Feature.Content = function ({ data }) {
  let content = [];
  let userPhoto = "";
  const addClassImageCircle = data?.active === "Y" ? " active" : "";
  if (data.photo !== "") {
    userPhoto = (
      <div
        className={`image-circle${addClassImageCircle}`}
        style={{
          background: "url('" + data.photo + "') no-repeat center",
          backgroundSize: "cover",
        }}
      />
    );
  } else {
    userPhoto = (
      <div className={`image-circle${addClassImageCircle}`}>
        <i
          className="material-icons"
          style={{ marginTop: "20px", marginLeft: "20px" }}
        >
          person
        </i>
      </div>
    );
  }
  content.push(
    <div
      key="content-view-top"
      className="row content-req"
      id="content-view-top"
    >
      <strong className="col s2 title">{userPhoto}</strong>
      <div className="col s10 desc">
        <span className="full_name">{data.full_name}</span>
        <span className="user_group">
          <b>User group : </b>
          {data.user_group}
        </span>
      </div>
    </div>
  );
  let leftBox = [];
  leftBox.push(
    <div key="content-view-id" className="row content-req">
      <strong className="col s4 title">IDU</strong>
      <div className="col s8 desc">{data.idu}</div>
    </div>
  );
  leftBox.push(
    <div key="content-view-status" className="row content-req">
      <strong className="col s4 title">Status</strong>
      <div
        className={
          "col s8 desc " + (data.active === "Y" ? "active" : "inactive")
        }
      >
        {data.active === "Y" ? "Active" : "Inactive"}
      </div>
    </div>
  );
  leftBox.push(
    <div key="content-view-email" className="row content-req">
      <strong className="col s4 title">E-mail</strong>
      <div className="col s8 desc">{data.email}</div>
    </div>
  );
  leftBox.push(
    <div key="content-view-position" className="row content-req">
      <strong className="col s4 title">Position</strong>
      <div className="col s8 desc">{data.position}</div>
    </div>
  );
  leftBox.push(
    <div key="content-view-department" className="row content-req">
      <strong className="col s4 title">Department</strong>
      <div className="col s8 desc">{data.department}</div>
    </div>
  );
  let rightBox = [];
  rightBox.push(
    <div key="content-view-division" className="row content-req">
      <strong className="col s4 title">Division</strong>
      <div className="col s8 desc">
        {data.division == null ? "N/A" : data.division}
      </div>
    </div>
  );
  rightBox.push(
    <div key="content-view-jobclass" className="row content-req">
      <strong className="col s4 title">Job Class</strong>
      <div className="col s8 desc">
        {data.job_class == null ? "N/A" : data.job_class}
      </div>
    </div>
  );
  rightBox.push(
    <div key="content-view-jobfunction" className="row content-req">
      <strong className="col s4 title">Job Function</strong>
      <div className="col s8 desc">
        {data.job_function == null ? "N/A" : data.job_function}
      </div>
    </div>
  );
  rightBox.push(
    <div key="content-view-workloca" className="row content-req">
      <strong className="col s4 title">Work Country</strong>
      <div className="col s8 desc">{data.work_loca}</div>
    </div>
  );
  rightBox.push(
    <div key="content-view-gcontact" className="row content-req">
      <ViewProfileBtnGContact data={data} />
    </div>
  );
  content.push(
    <div
      key="content-view-box"
      className="row"
      style={{ padding: "0 10px", paddingTop: "10px" }}
    >
      <div className="col s6">{leftBox}</div>
      <div className="col s6">{rightBox}</div>
    </div>
  );

  return <div>{content}</div>;
};

export default function ModalView({ userData }) {
  const [itemData, setItemData] = useState({
    data: {},
    status: "",
    err: 0,
    err_msg: "",
  });
  let header = "View Profile";
  let content = "";
  let footer = "";
  let btns = [<div className="header">{header}</div>];
  let modalCSS = {};
  modalCSS.height = "70%";
  modalCSS.maxHeight = "440px";
  const handleEvents = {
    OnClose: function () {
      $("body").css({ overflow: "auto" });
      setItemData({ data: {}, status: "", err: 0, err_msg: "" });
    },
  };
  useEffect(() => {
    $("#main-content").on("click", ".btn-view", function (evt) {
      setItemData({ status: "processing" });
      const userId = $(this).attr("user-id");
      const mainFunc = async () =>
        await API.post("alluser/view/data", {
          params: ({
            id: userId,
          }),
        });
      mainFunc()
        .then((res) => {
          const decrypt = (res?.data);
          // console.log("alluser viewr=>", decrypt);
          if (decrypt?.status === "success") {
            setItemData(decrypt);
          } else {
            setItemData({
              err: 1,
              err_msg: `Failes : ${decrypt?.err_msg ?? ""}`,
            });
          }
        })
        .catch((err) => {
          //console.log(`Failes : ${err}`);
          setItemData({ data: {}, status: "", err: 1, err_msg: err });
        });
    });
  }, []);

  if (itemData.status === "") {
    return "";
  } else if ("err" in itemData && itemData.err === 1) {
    modalCSS.height = "170px";
    btns.push(
      <Button
        flat
        modal="close"
        node="button"
        waves="red"
        className="modal-close"
      >
        <i className="material-icons">close</i>
      </Button>
    );
    content = (
      <div className="text-error">Fetch request error: {itemData.err_msg}</div>
    );
  } else if (itemData.status !== "success") {
    content = (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto",
            },
          }}
        />
      </div>
    );
  } else {
    //console.log("View", itemData);
    btns.push(
      <Button
        flat
        modal="close"
        node="button"
        waves="red"
        className="modal-close"
      >
        <i className="material-icons">close</i>
      </Button>
    );

    content = (
      <div
        className="modal-content-outer"
        style={{
          bottom:
            userData?.user_sess?.isAdmin ||
            userData?.idu === itemData?.data?.idu
              ? "50px"
              : "auto",
        }}
      >
        <div key="modal-content-inner" className="modal-content-inner">
          <Feature.Content data={itemData.data} />
        </div>
        <div key="modal-loading" className="modal-loading hide">
          <Html.Preloading
            addon={{
              css: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                margin: "auto",
              },
            }}
          />
        </div>
      </div>
    );

    if (userData?.user_sess?.isAdmin || userData?.idu === itemData?.data?.idu) {
      footer = (
        <div className="modal-footer-bottom">
          <span className="modal-error-text hide"></span>
          <ViewProfileBtnChange data={itemData.data} />
          {userData?.idu === itemData?.data?.idu ? (
            <ViewProfileBtnMyProfile />
          ) : (
            ""
          )}
        </div>
      );
    }
  }

  return (
    <Modal
      actions={btns}
      bottomSheet={false}
      fixedFooter={false}
      className="modal-user modal-user-footer"
      id="modal-user-view"
      open={true}
      options={{
        dismissible: true,
        endingTop: "10%",
        inDuration: 250,
        onCloseEnd: null,
        onCloseStart: handleEvents.OnClose,
        onOpenEnd: null,
        onOpenStart: null,
        opacity: 0.5,
        outDuration: 250,
        preventScrolling: true,
        startingTop: "5%",
      }}
      root={document.getElementById("root")}
      style={modalCSS}
    >
      {content}
      {footer}
    </Modal>
  );
}

